import { Form, Formik } from 'formik';
import { Props, Values } from './SignInForm.types';
import * as Yup from 'yup';
import FormField from '../../components/field/FormField';
import Button from '../../components/button/Button';

export const SignInForm = ({ onSubmit, initialValues }: Props) => {
  const _initialValues: Values = {
    email: '',
    password: '',
  };

  const SignInSchema = Yup.object().shape({
    email: Yup.string().email('E-mail is invalid').required('E-mail is required.'),
    password: Yup.string().required('Password is required.'),
  });

  return (
    <Formik
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={SignInSchema}
    >
      {({ errors, touched }) => (
        <Form>
          <div className="my-4">
            <FormField id="email" name="email" label="E-mail" errors={errors} touched={touched} />
          </div>

          <div className="my-4">
            <FormField
              id="password"
              name="password"
              type="password"
              label="Password"
              errors={errors}
              touched={touched}
            />
          </div>
          <Button type="submit" title="Sign in" fullWidth />
        </Form>
      )}
    </Formik>
  );
};
